import { css } from 'styled-components'

export const PopoverStyles = css`
  .ant-popover .ant-popover-inner {
    padding: 0;
  }
`
